var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _ellipse, _path24, _rect, _rect2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _path33, _path34, _path35, _path36, _path37, _path38, _g2, _path39, _path40, _path41, _path42, _g3, _path43, _path44, _path45, _g4, _path46, _path47, _path48, _path49, _path50, _g5, _path51, _path52, _path53, _g6, _path54, _path55, _path56, _g7, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g8, _path67, _path68, _path69, _path70, _path71, _g9, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _g10, _path80, _path81, _path82, _path83, _g11, _path84, _path85, _path86, _path87, _path88, _ellipse2, _ellipse3, _ellipse4, _path89, _path90, _g12, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 180,
    viewBox: "0 0 236 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.286 15.1345C147.096 8.06714 151.86 1.37283 158.927 0.182335C165.995 -1.00816 172.689 3.756 173.879 10.8234C175.07 17.8908 170.306 24.5851 163.238 25.7756C156.171 26.9661 149.477 22.2019 148.286 15.1345ZM157.163 13.6392C157.528 15.804 159.578 17.2633 161.743 16.8987C162.783 16.7235 163.71 16.1426 164.322 15.2837C164.933 14.4248 165.178 13.3583 165.003 12.3187C164.638 10.1539 162.588 8.69463 160.423 9.05929C158.258 9.42395 156.799 11.4745 157.163 13.6392Z",
    fill: "#CDE2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3974 122.277C24.2069 115.21 28.9711 108.516 36.0385 107.325C43.1058 106.135 49.8002 110.899 50.9907 117.966C52.1811 125.034 47.417 131.728 40.3496 132.918C33.2822 134.109 26.5879 129.345 25.3974 122.277ZM34.2746 120.782C34.6392 122.947 36.6897 124.406 38.8545 124.042H38.8545C39.8941 123.866 40.8215 123.285 41.4328 122.427C42.044 121.568 42.2891 120.501 42.1139 119.462C41.7493 117.297 39.6988 115.837 37.534 116.202C35.3692 116.567 33.9099 118.617 34.2746 120.782Z",
    fill: "#CDE2FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.098 95.5477C222.502 92.0103 224.887 88.6595 228.425 88.0636C230.123 87.7775 231.866 88.1779 233.27 89.1767C234.673 90.1756 235.623 91.6911 235.909 93.3899C236.505 96.9273 234.12 100.278 230.582 100.874C227.045 101.47 223.694 99.0852 223.098 95.5477ZM227.818 95.5249C228.245 96.2069 229.041 96.5644 229.834 96.4307C230.918 96.2482 231.648 95.2219 231.466 94.1383C231.332 93.3448 230.733 92.7099 229.949 92.5297C229.165 92.3495 228.349 92.6595 227.883 93.3152C227.416 93.9708 227.39 94.843 227.818 95.5249Z",
    fill: "#CDE2FD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170.182,
    cy: 53.5216,
    r: 3.43054,
    fill: "#AED3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5321,
    cy: 138.678,
    r: 3.43054,
    fill: "#AED3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8987 55.8283L8.07574 56.3038L7.60021 53.4809C7.42849 52.4615 6.4629 51.7743 5.4435 51.946C4.4241 52.1177 3.73692 53.0833 3.90863 54.1027L4.38415 56.9257L1.56117 57.4012C0.54177 57.5729 -0.145416 58.5385 0.0262995 59.5579C0.198021 60.5773 1.16361 61.2645 2.18302 61.0928L5.006 60.6173L5.48152 63.4402C5.65324 64.4596 6.61884 65.1468 7.63824 64.9751C8.65764 64.8034 9.34483 63.8378 9.17311 62.8184L8.69759 59.9954L11.5206 59.5199C12.54 59.3482 13.2272 58.3826 13.0554 57.3632C12.8837 56.3438 11.9181 55.6566 10.8987 55.8283Z",
    fill: "#0084F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.561 107.855L118.738 108.331L118.262 105.508C118.091 104.488 117.125 103.801 116.106 103.973C115.086 104.144 114.399 105.11 114.571 106.129L115.046 108.952L112.223 109.428C111.204 109.6 110.517 110.565 110.688 111.585C110.86 112.604 111.826 113.291 112.845 113.12L115.668 112.644L116.144 115.467C116.315 116.486 117.281 117.174 118.3 117.002C119.32 116.83 120.007 115.865 119.835 114.845L119.36 112.022L122.183 111.547C123.202 111.375 123.889 110.409 123.718 109.39C123.546 108.37 122.58 107.683 121.561 107.855Z",
    fill: "#D9E9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M181.306 157.942L178.483 158.418L178.007 155.595C177.836 154.575 176.87 153.888 175.851 154.06C174.831 154.232 174.144 155.197 174.316 156.217L174.791 159.04L171.968 159.515C171.479 159.598 171.042 159.871 170.754 160.276C170.466 160.68 170.351 161.182 170.433 161.672C170.605 162.691 171.571 163.378 172.59 163.207L175.413 162.731L175.889 165.554C176.06 166.574 177.026 167.261 178.045 167.089C179.065 166.917 179.752 165.952 179.58 164.932L179.105 162.109L181.928 161.634C182.947 161.462 183.634 160.497 183.463 159.477C183.291 158.458 182.325 157.771 181.306 157.942Z",
    fill: "#0084F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2851 156.55L40.6112 156.07L41.0908 155.396C41.264 155.153 41.2071 154.815 40.9637 154.642C40.7204 154.469 40.3827 154.526 40.2095 154.769L39.7298 155.443L39.0559 154.963C38.8125 154.79 38.4749 154.847 38.3017 155.09C38.1285 155.334 38.1853 155.671 38.4287 155.845L39.1026 156.324L38.623 156.998C38.4498 157.242 38.5067 157.579 38.7501 157.752C38.9934 157.926 39.3311 157.869 39.5043 157.625L39.984 156.951L40.6579 157.431C40.9013 157.604 41.239 157.547 41.4121 157.304C41.5853 157.061 41.5285 156.723 41.2851 156.55Z",
    fill: "#0084F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7919 23.2076C70.7372 22.8783 70.4855 22.6167 70.1586 22.5494C67.3321 21.9925 64.8811 20.2481 63.4289 17.7601C63.2582 17.4733 62.9286 17.3212 62.5996 17.3774C62.2704 17.4321 62.0088 17.6838 61.9414 18.0106C61.3845 20.8372 59.6402 23.2882 57.152 24.7403C56.8653 24.911 56.7132 25.2407 56.7694 25.5697C56.824 25.8989 57.0757 26.1605 57.4026 26.2279C60.2291 26.7847 62.6802 28.5291 64.1323 31.0172C64.303 31.304 64.6327 31.4561 64.9616 31.3998C65.2909 31.3452 65.5525 31.0935 65.6198 30.7666C66.1767 27.9401 67.9211 25.489 70.4092 24.0369C70.696 23.8662 70.8481 23.5366 70.7919 23.2076Z",
    fill: "#D9E9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.051 52.489C218.997 52.1598 218.745 51.8982 218.418 51.8308C215.592 51.2739 213.141 49.5296 211.688 47.0415C211.518 46.7547 211.188 46.6026 210.859 46.6588C210.53 46.7135 210.268 46.9652 210.201 47.2921C209.644 50.1186 207.9 52.5696 205.412 54.0218C205.125 54.1925 204.973 54.5221 205.029 54.8511C205.084 55.1803 205.335 55.4419 205.662 55.5093C208.489 56.0661 210.94 57.8105 212.392 60.2986C212.563 60.5854 212.892 60.7375 213.221 60.6813C213.55 60.6266 213.812 60.3749 213.879 60.048C214.436 57.2215 216.181 54.7705 218.669 53.3183C218.955 53.1476 219.108 52.818 219.051 52.489Z",
    fill: "#D9E9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8672 39.8782L10.6834 56.0689C10.6834 56.0689 10.4763 9.07533 46.1562 8.1779C71.0609 7.55148 74.445 27.7152 74.445 27.7152L67.8672 39.8782Z",
    fill: "#004E9C",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3593 178.153C52.108 155.44 112.203 152.441 75.9398 129.075C34.1803 102.167 181.046 -2.80026 43.2176 8.36323C43.2176 8.36323 92.1759 12.3445 42.6 79.31C-6.85213 146.108 73.9414 119.261 57.9763 152.92C48.601 172.685 71.3593 178.153 71.3593 178.153Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2017 49.8889H63.7732L71.5544 31.5879H81.9829L74.2017 49.8889Z",
    fill: "#004E9C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6194 34.9991H83.9785C83.4917 34.9991 83.3606 34.3793 83.6856 33.6148L83.9588 32.9722C84.2839 32.2077 84.9421 31.5879 85.4289 31.5879H100.07C100.557 31.5879 100.688 32.2077 100.363 32.9722L100.089 33.6148C99.7643 34.3793 99.1062 34.9991 98.6194 34.9991Z",
    fill: "#004E9C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.634 42.0202H80.9931C80.5064 42.0202 80.3752 41.4004 80.7003 40.6358L80.9735 39.9933C81.2986 39.2287 81.9567 38.6089 82.4435 38.6089H97.0844C97.5712 38.6089 97.7023 39.2287 97.3772 39.9933L97.104 40.6358C96.779 41.4004 96.1208 42.0202 95.634 42.0202Z",
    fill: "#004E9C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6489 49.0412H78.008C77.5212 49.0412 77.3901 48.4214 77.7152 47.6569L77.9884 47.0143C78.3135 46.2497 78.9716 45.6299 79.4584 45.6299H94.0993C94.5861 45.6299 94.7172 46.2497 94.3921 47.0143L94.1189 47.6569C93.7939 48.4214 93.1357 49.0412 92.6489 49.0412Z",
    fill: "#004E9C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4116 59.0272H60.4142C60.1234 59.0272 60.045 58.6569 60.2392 58.2002L60.4025 57.8163C60.5967 57.3595 60.9899 56.9893 61.2807 56.9893H86.2781C86.569 56.9893 86.6473 57.3595 86.4531 57.8163L86.2899 58.2002C86.0957 58.6569 85.7025 59.0272 85.4116 59.0272Z",
    fill: "#004E9C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6968 65.4128H57.6994C57.4085 65.4128 57.3302 65.0426 57.5244 64.5858L57.6876 64.2019C57.8818 63.7451 58.275 63.3749 58.5658 63.3749H83.5633C83.8541 63.3749 83.9324 63.7452 83.7382 64.2019L83.575 64.5858C83.3808 65.0426 82.9876 65.4128 82.6968 65.4128Z",
    fill: "#004E9C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9819 71.7985H54.9845C54.6937 71.7985 54.6154 71.4282 54.8096 70.9714L54.9728 70.5875C55.167 70.1308 55.5602 69.7605 55.851 69.7605H80.8484C81.1393 69.7605 81.2176 70.1308 81.0234 70.5875L80.8602 70.9714C80.666 71.4282 80.2728 71.7985 79.9819 71.7985Z",
    fill: "#004E9C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2669 78.184H52.2694C51.9786 78.184 51.9003 77.8138 52.0945 77.357L52.2577 76.9731C52.4519 76.5164 52.8451 76.1461 53.1359 76.1461H78.1334C78.4242 76.1461 78.5025 76.5164 78.3083 76.9731L78.1451 77.357C77.9509 77.8138 77.5577 78.184 77.2669 78.184Z",
    fill: "#004E9C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3416 86.7435H48.6298C48.3389 86.7435 48.2606 86.3732 48.4548 85.9165L48.618 85.5326C48.8122 85.0758 49.2054 84.7056 49.4963 84.7056H61.2081C61.4989 84.7056 61.5772 85.0758 61.383 85.5326L61.2198 85.9165C61.0256 86.3732 60.6324 86.7435 60.3416 86.7435Z",
    fill: "#004E9C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8307 113.008C61.233 114.867 58.3709 116.326 55.3401 117.336",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6538 16.3156L75.7532 18.2273",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M215.203 112.184H153.819C148.074 112.184 143.418 107.5 143.418 101.722V45.2345C143.418 39.4567 148.074 34.7728 153.819 34.7728H215.203C220.947 34.7728 225.604 39.4567 225.604 45.2345V101.722C225.604 107.5 220.947 112.184 215.203 112.184Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.511,
    cy: 57.2951,
    rx: 12.9254,
    ry: 13.0167,
    fill: "#0084F0",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M180.909 57.2951V52.499C180.908 52.2086 181.061 51.9395 181.312 51.7936C181.563 51.6476 181.873 51.6471 182.125 51.7923L186.249 54.1904L190.374 56.5884C190.625 56.7353 190.779 57.0043 190.779 57.2951C190.779 57.5858 190.625 57.8548 190.374 58.0017L186.249 60.3998L182.125 62.7978C181.873 62.943 181.563 62.9425 181.312 62.7966C181.061 62.6506 180.908 62.3815 180.909 62.0912V57.2951Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 155.286,
    y: 80.5511,
    width: 58.4497,
    height: 4.50864,
    rx: 0.90474,
    fill: "#004E9C",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 168.617,
    y: 90.1319,
    width: 31.7869,
    height: 4.50864,
    rx: 0.90474,
    fill: "#004E9C",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.523 45.9762C164.005 46.6298 163.341 47.1525 162.584 47.502",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M209.228 98.1105L207.934 99.197",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1177 62.0604L87.6332 58.7997L88.6769 55.3173L92.3333 54.7249L93.373 58.8706L90.9472 60.0379L88.2599 63.804L85.1177 62.0604Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2885 56.8562C88.4831 63.6334 94.9773 60.9064 93.1298 57.9008C90.6185 59.2027 90.8923 56.7584 90.8923 56.7584C90.8923 56.7584 92.0467 56.0867 91.4481 55.2145C91.4481 55.2145 92.3167 54.6589 92.4672 55.2588C93.3506 53.9139 92.5749 53.7943 89.9212 53.8465C86.509 53.9136 87.386 59.2188 87.386 59.2188C87.386 59.2188 89.1104 61.2471 90.2885 56.8562Z",
    fill: "#0084F0",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1941 57.1905C88.523 56.0523 88.3271 58.2478 89.6892 59.2502L90.1941 57.1905Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1941 57.1905C88.523 56.0523 88.3271 58.2478 89.6892 59.2502",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2729 100.82L88.0966 100.86L89.14 94.2462L85.7034 94.197L85.2729 100.82Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_2807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 94,
    width: 5,
    height: 7
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2729 100.82L88.0966 100.861L89.14 94.2462L85.7034 94.197L85.2729 100.82Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_2807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.6577 97.6532C88.4339 98.7454 87.0686 97.5177 88.6523 97.3369C90.236 97.1562 85.2728 96.1802 85.2728 96.1802L84.5523 96.5752",
    fill: "#004E9C"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2729 100.82L88.0966 100.86L89.14 94.2462L85.7034 94.197L85.2729 100.82V100.82Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5037 102.869C94.634 101.698 94.0105 101.761 93.0731 101.529C91.0037 101.018 88.6837 101.182 88.569 99.0156L85.0331 99.3422L84.853 101.771C84.8067 102.243 85.0967 102.641 85.4913 102.646L94.5037 102.869Z",
    fill: "#0084F0",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M84.878 96.8824C87.0011 98.6479 89.6845 96.8278 89.6845 96.8278L91.751 83.2518C91.9227 81.6307 91.3236 80.023 90.133 78.9095L81.2788 70.6447L74.5178 74.5882L85.8467 84.1107L84.878 96.8824Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.878 96.8824C87.0011 98.6479 89.6845 96.8278 89.6845 96.8278L91.751 83.2518C91.9227 81.6307 91.3236 80.023 90.133 78.9095L81.2788 70.6447L74.5178 74.5882L85.8467 84.1107L84.878 96.8824Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1819 97.3453L59.2003 99.3302L64.4844 95.2599L62.0278 92.8441L57.1819 97.3453Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5_2807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 92,
    width: 8,
    height: 8
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1819 97.3453L59.2003 99.3302L64.4844 95.2599L62.0278 92.8441L57.1819 97.3453Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5_2807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4009 95.6457C60.3124 94.4376 61.055 97.6907 62.7185 97.0865C64.3821 96.4823 60.2695 92.8441 60.2695 92.8441L55.0478 93.7401",
    fill: "#004E9C"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1819 97.3453L59.2003 99.3302L64.4844 95.2599L62.0278 92.8441L57.1819 97.3453V97.3453Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2705 102.457C64.9687 101.511 62.8223 101.214 62.8223 101.214C61.4246 101.175 59.2002 99.3302 60.6782 98.2881L58.0503 96.3298L55.6545 98.4612C55.3784 98.8458 55.4299 99.3361 55.768 99.5406L60.4768 102.457L64.2705 102.457Z",
    fill: "#0084F0",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1974 71.3196L74.5531 68.2789L71.6466 84.3101L59.3235 94.366C59.3235 94.366 61.5916 97.376 63.7412 97.7786L74.5387 89.6213C75.6552 88.9714 76.5224 87.9669 77.0025 86.7675L80.8793 77.1002",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5_2807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 68,
    width: 25,
    height: 30
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1974 71.3196L74.5531 68.2789L71.6466 84.3101L59.3235 94.366C59.3235 94.366 61.5916 97.376 63.7412 97.7786L74.5387 89.6213C75.6552 88.9714 76.5224 87.9669 77.0025 86.7675L80.8793 77.1002",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5_2807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.2605 82.8029C77.7298 73.0151 74.2959 74.0814 80.9731 74.6228C89.169 75.2872 80.459 73.3684 80.459 73.3684L79.2481 66.599L73.4227 64.377L72.6207 64.8898L68.4574 70.6447L63.2744 85.5714",
    fill: "#004E9C"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1974 71.3196L74.5531 68.2789L71.6466 84.3101L59.3235 94.366C59.3235 94.366 61.5916 97.376 63.7412 97.7786L74.5387 89.6213C75.6552 88.9714 76.5224 87.9669 77.0025 86.7675L80.8793 77.1002",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7966 59.7683C88.3236 59.9603 88.3361 62.7326 88.3361 62.7326L85.6529 68.2188C85.6529 68.2188 83.3469 74.6021 82.2912 74.7348C76.9603 74.1562 72.1111 69.0916 72.1111 69.0916C72.1111 69.0916 82.1339 59.5471 86.7966 59.7683Z",
    fill: "#0084F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5_2807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 59,
    width: 17,
    height: 16
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7966 59.7683C88.3236 59.9603 88.3361 62.7326 88.3361 62.7326L85.6529 68.2188C85.6529 68.2188 83.3469 74.6021 82.2912 74.7348C76.9603 74.1562 72.1111 69.0916 72.1111 69.0916C72.1111 69.0916 82.1339 59.5471 86.7966 59.7683Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5_2807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8646 63.714C83.4297 66.9805 84.2604 72.7159 84.2604 72.7159L87.6213 70.6446L84.8646 63.714Z",
    fill: "#0084F0",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7966 59.7683C88.3236 59.9603 88.3361 62.7326 88.3361 62.7326L85.6529 68.2188C85.6529 68.2188 83.3469 74.6021 82.2912 74.7348C76.9603 74.1562 72.1111 69.0916 72.1111 69.0916C72.1111 69.0916 82.1339 59.5471 86.7966 59.7683Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M103.71 75.4988L80.3576 85.5035C80.0098 85.6521 79.6171 85.6558 79.2666 85.5138C78.9161 85.3719 78.6367 85.096 78.4902 84.7474L73.1163 72.0574C72.8078 71.3311 73.1436 70.492 73.8681 70.1792L97.2206 60.1745C97.5684 60.0259 97.961 60.0222 98.3115 60.1642C98.662 60.3061 98.9415 60.582 99.0879 60.9306L104.462 73.6206C104.77 74.3469 104.435 75.186 103.71 75.4988Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.71 75.4988L80.3576 85.5035C80.0098 85.6521 79.6171 85.6558 79.2666 85.5138C78.9161 85.3719 78.6367 85.096 78.4902 84.7474L73.1163 72.0574C72.8078 71.3311 73.1436 70.492 73.8681 70.1792L97.2206 60.1745C97.5684 60.0259 97.961 60.0222 98.3115 60.1642C98.662 60.3061 98.9415 60.582 99.0879 60.9306L104.462 73.6206C104.77 74.3469 104.435 75.186 103.71 75.4988Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4582 64.5213L76.8196 73.3633C76.0675 73.6881 75.7188 74.5593 76.0391 75.3133L78.7876 81.8036C78.9226 82.1249 79.1802 82.3791 79.5032 82.51C79.8263 82.6408 80.1881 82.6373 80.5087 82.5005L101.452 73.5277C102.12 73.2394 102.43 72.466 102.145 71.7966L99.3968 65.3063C99.2448 64.9444 98.9546 64.658 98.5907 64.5106C98.2268 64.3633 97.8192 64.3671 97.4582 64.5213Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5_2807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 64,
    width: 28,
    height: 19
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4582 64.5213L76.8196 73.3633C76.0675 73.6881 75.7188 74.5593 76.0391 75.3133L78.7876 81.8036C78.9226 82.1249 79.1802 82.3791 79.5032 82.51C79.8263 82.6408 80.1881 82.6373 80.5087 82.5005L101.452 73.5277C102.12 73.2394 102.43 72.466 102.145 71.7966L99.3968 65.3063C99.2448 64.9444 98.9546 64.658 98.5907 64.5106C98.2268 64.3633 97.8192 64.3671 97.4582 64.5213Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5_2807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4631 86.218L71.623 84.2343C75.5683 82.9727 74.1653 80.4118 78.3572 80.5308C82.5492 80.6499 79.9642 73.5629 83.2584 75.3136C86.5527 77.0642 86.2081 74.4952 87.8816 74.9362C89.555 75.3772 88.9965 70.673 91.9809 71.5767C94.9653 72.4803 92.8938 65.7078 96.0277 67.2154C99.1617 68.723 100.51 63.3802 102.762 64.6865C105.014 65.9929 105.739 62.5647 106.499 62.7291L109.692 70.2683L72.4631 86.218Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4582 64.5213L76.8196 73.3633C76.0675 73.6881 75.7188 74.5593 76.0391 75.3133L78.7876 81.8036C78.9226 82.1249 79.1802 82.3791 79.5032 82.51C79.8263 82.6408 80.1881 82.6373 80.5087 82.5005L101.452 73.5277C102.12 73.2394 102.43 72.466 102.145 71.7966L99.3968 65.3063C99.2448 64.9444 98.9546 64.658 98.5907 64.5106C98.2268 64.3633 97.8192 64.3671 97.4582 64.5213V64.5213Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8571 74.93C92.2963 76.1272 94.0878 76.7437 94.2637 77.193C94.4396 77.6423 93.5788 77.3839 93.5788 77.3839C93.5788 77.3839 95.7489 78.4778 95.7455 78.9117C95.742 79.3457 94.5823 78.7333 94.5823 78.7333C94.5823 78.7333 95.3395 79.0111 95.4272 79.2354C95.5149 79.4597 94.4171 80.1065 89.6702 76.8031",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5_2807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 74,
    width: 7,
    height: 6
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8571 74.93C92.2963 76.1272 94.0878 76.7437 94.2637 77.193C94.4396 77.6423 93.5788 77.3839 93.5788 77.3839C93.5788 77.3839 95.7489 78.4778 95.7455 78.9117C95.742 79.3457 94.5823 78.7333 94.5823 78.7333C94.5823 78.7333 95.3395 79.0111 95.4272 79.2354C95.5149 79.4597 94.4171 80.1065 89.6702 76.8031",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5_2807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4892 79.2772C91.5223 78.7121 91.7798 75.1451 91.7798 75.1451L89.6703 76.2023L89.2734 77.7825",
    fill: "#004E9C"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8571 74.93C92.2963 76.1272 94.0878 76.7437 94.2637 77.193C94.4396 77.6423 93.5788 77.3839 93.5788 77.3839C93.5788 77.3839 95.7489 78.4778 95.7455 78.9117C95.742 79.3457 94.5823 78.7333 94.5823 78.7333C94.5823 78.7333 95.3395 79.0111 95.4272 79.2354C95.5149 79.4597 94.4171 80.1065 89.6702 76.8031",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9304 63.7003L85.4772 71.0098C85.5301 71.3051 85.6419 71.5868 85.8059 71.838L89.83 77.9988C91.0804 77.8145 91.7796 75.1451 91.7796 75.1451L89.8125 70.0075L88.2118 61.6306",
    fill: "#0084F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_5_2807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 61,
    width: 9,
    height: 17
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9304 63.7003L85.4772 71.0098C85.5301 71.3051 85.6419 71.5868 85.8059 71.838L89.83 77.9988C91.0804 77.8145 91.7796 75.1451 91.7796 75.1451L89.8125 70.0075L88.2118 61.6306",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_5_2807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3483 72.9604C90.3009 75.5942 88.3361 76.8956 88.3361 76.8956L86.8198 76.3069C86.8198 76.3069 90.609 73.7351 91.1943 71.8759C91.7796 70.0168 91.3483 72.9604 91.3483 72.9604Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9304 63.7003L85.4772 71.0098C85.5301 71.3051 85.6419 71.5868 85.8059 71.838L89.83 77.9988C91.0804 77.8145 91.7796 75.1451 91.7796 75.1451L89.8125 70.0075L88.2118 61.6306",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6186 69.9016C89.4 70.1012 89.1141 70.211 88.8181 70.209",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1543 65.6871L78.0261 66.3678",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6279 84.1554C71.6885 84.6871 72.2817 85.0875 72.7938 84.9424",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9651 71.5753C96.0009 72.3367 95.8749 73.0971 95.5955 73.8062",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M61.29 98.714L60.4087 98.9223C60.4072 98.9595 60.4497 98.9805 60.485 98.9918L61.8524 99.4293",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7205 98.8572L88.604 99.5606L90.2351 99.6514",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M129.7 151.229C110.118 155.923 103.461 148.242 103.461 148.242C103.461 148.242 110.998 106.661 126.496 104.48C141.993 102.299 129.7 151.229 129.7 151.229Z",
    fill: "#0084F0",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2514 100.012C55.864 95.4091 67.2391 103.695 67.2391 103.695C67.2391 103.695 85.0302 101.7 87.7601 103.695C90.49 105.69 117.207 132.081 117.207 132.081L97.894 135.487C97.894 135.487 81.4075 111.817 80.1826 110.735C79.2118 109.877 64.2483 107.341 63.596 107.052C62.9436 106.764 56.2514 100.012 56.2514 100.012Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_5_2807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 98,
    width: 62,
    height: 38
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2514 100.012C55.864 95.4091 67.2391 103.695 67.2391 103.695C67.2391 103.695 85.0302 101.7 87.7601 103.695C90.49 105.69 117.207 132.081 117.207 132.081L97.894 135.487C97.894 135.487 81.4075 111.817 80.1826 110.735C79.2118 109.877 64.2483 107.341 63.596 107.052C62.9436 106.764 56.2514 100.012 56.2514 100.012Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_5_2807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.9338 117.928C96.1001 123.852 108.003 121.814 108.003 121.814L97.8941 135.487L81.6821 128.579L80.7004 124.901",
    fill: "#004E9C"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2514 100.012C55.864 95.4091 67.2391 103.695 67.2391 103.695C67.2391 103.695 85.0302 101.7 87.7601 103.695C90.49 105.69 117.207 132.081 117.207 132.081L97.894 135.487C97.894 135.487 81.4075 111.817 80.1826 110.735C79.2118 109.877 64.2483 107.341 63.596 107.052C62.9436 106.764 56.2514 100.012 56.2514 100.012Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M130.922 177.791L198.865 175.838C198.865 175.838 180.173 107.766 175.456 103.825C170.94 100.053 145.812 97.0953 129.098 105.061C128.353 105.416 127.365 105.504 126.941 106.188C116.452 123.104 130.922 177.791 130.922 177.791Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.922 177.791L198.865 175.838C198.865 175.838 180.173 107.766 175.456 103.825C170.94 100.053 145.812 97.0953 129.098 105.061C128.353 105.416 127.365 105.504 126.941 106.188C116.452 123.104 130.922 177.791 130.922 177.791Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M133.801 86.6031L139.497 109.871L153.988 100.217L145.247 80.9551L133.801 86.6031Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_5_2807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 80,
    width: 21,
    height: 30
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.801 86.603L139.497 109.871L153.988 100.217L145.247 80.9551L133.801 86.603Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_5_2807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.154 109.87C149.555 107.203 133.738 94.9769 138.769 91.6453C140.154 90.7288 136.486 85.6068 136.486 85.6068L132.757 88.9066",
    fill: "#004E9C"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.801 86.6031L139.497 109.871L153.988 100.217L145.247 80.9551L133.801 86.6031V86.6031Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M142.338 80.871L136.685 71.4194L123.489 63.7754C123.249 74.8357 116.884 106.716 138.77 91.6453",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M142.338 80.871L136.685 71.4194L123.489 63.7754C123.249 74.8357 116.884 106.716 138.77 91.6453",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M144.041 81.3105C139.836 83.7308 132.414 75.7133 134.633 72.4626C134.633 72.4626 127.554 76.5791 121.635 72.9351C104.016 77.8482 102.044 55.4923 118.693 59.5732C126.244 53.8562 136.003 57.022 136.328 62.1558C150.637 51.8958 156.57 74.1001 144.041 81.3105Z",
    fill: "#0084F0",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M145.499 86.0063C152.562 78.029 145.098 68.6947 137.678 82.3517L145.499 86.0063Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M145.499 86.0063C152.562 78.029 145.098 68.6947 137.678 82.3517",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M211.299 168.213L198.101 128.579H178.365L189.273 158.646L150.639 169.952L146.801 170.821C146.801 170.821 140.764 164.991 138.801 165.554C136.838 166.117 125.594 174.748 125.594 174.748H146.326L145.958 177.791H205.163C210.082 177.791 212.981 173.265 211.299 168.213Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_5_2807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 128,
    width: 87,
    height: 50
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.299 168.213L198.101 128.579H178.365L189.273 158.646L150.639 169.952L146.801 170.821C146.801 170.821 140.764 164.991 138.801 165.554C136.838 166.117 125.594 174.748 125.594 174.748H146.326L145.958 177.791H205.163C210.082 177.791 212.981 173.265 211.299 168.213Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_5_2807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.719 147.117C166.922 153.041 201.936 146.459 208.316 159.953C214.696 173.447 213.06 135.487 213.06 135.487L208.316 133.787",
    fill: "#004E9C"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.299 168.213L198.101 128.579H178.365L189.273 158.646L150.639 169.952L146.801 170.821C146.801 170.821 140.764 164.991 138.801 165.554C136.838 166.117 125.594 174.748 125.594 174.748H146.326L145.958 177.791H205.163C210.082 177.791 212.981 173.265 211.299 168.213Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M132.368 174.756H180.219C182.589 174.756 184.511 176.677 184.511 179.048V179.06H132.368V174.756V174.756Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M182.579 148.918C202.951 153.611 208.316 145.931 208.316 145.931C208.316 145.931 193.781 104.35 177.916 102.169C162.051 99.988 182.579 148.918 182.579 148.918Z",
    fill: "#0084F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_5_2807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 102,
    width: 38,
    height: 49
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.579 148.918C202.951 153.611 208.316 145.931 208.316 145.931C208.316 145.931 193.781 104.35 177.916 102.169C162.051 99.988 182.579 148.918 182.579 148.918Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_5_2807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.9 141.969C205.062 152.83 213.06 135.487 213.06 135.487L214.388 152.748C214.388 152.748 160.997 159.598 162.562 159.106",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.9 141.969C205.062 152.83 213.06 135.487 213.06 135.487L214.388 152.748C214.388 152.748 160.997 159.598 162.562 159.106",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.579 148.918C202.951 153.611 208.316 145.931 208.316 145.931C208.316 145.931 193.781 104.35 177.916 102.169C162.051 99.988 182.579 148.918 182.579 148.918Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M142.544 179.06H73.3985C71.9805 179.06 70.6361 178.154 70.0288 176.789L46.9118 124.819C46.4414 123.761 47.1089 122.637 48.2073 122.637H118.143C119.561 122.637 120.905 123.544 121.513 124.909L144.291 176.118C144.926 177.544 144.026 179.06 142.544 179.06Z",
    fill: "#004E9C"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.544 179.06H73.3985C71.9805 179.06 70.6361 178.154 70.0288 176.789L46.9118 124.819C46.4414 123.761 47.1089 122.637 48.2073 122.637H118.143C119.561 122.637 120.905 123.544 121.513 124.909L144.291 176.118C144.926 177.544 144.026 179.06 142.544 179.06Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M143.946 113.77L139.497 109.871C139.497 109.871 150.726 94.2621 151.149 93.9599C152.177 93.2247 158.694 100.108 158.694 100.108L143.946 113.77Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M136.361 113.77L140.154 109.871C140.154 109.871 136.637 97.2738 136.163 96.9716C135.011 96.2364 131.3 104.107 131.3 104.107L136.361 113.77Z",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.5704,
    cy: 150.849,
    rx: 2.41452,
    ry: 4.6909,
    transform: "rotate(-51.1503 89.5704 150.849)",
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.154,
    cy: 117.054,
    rx: 1.30853,
    ry: 1.31615,
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.805,
    cy: 128.579,
    rx: 1.30853,
    ry: 1.31615,
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M124.228 78.6114C119.686 80.5468 120.464 85.1423 123.478 84.6L124.228 78.6114Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M124.228 78.6114C119.686 80.5468 120.464 85.1423 123.478 84.6",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.829,
    cy: 82.4044,
    rx: 2.56918,
    ry: 1.90557,
    fill: "#004E9C"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M129.289 84.9301C127.532 86.8985 125.317 86.2873 125.317 86.2873L129.289 84.9301Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M129.289 84.9301C127.532 86.8985 125.317 86.2873 125.317 86.2873",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M142.338 81.1716C142.662 80.6156 143.521 80.4805 143.999 80.9106C144.476 81.3407 144.436 82.2146 143.922 82.5989",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M121.261 64.2108C121.825 65.4197 122.713 66.449 123.825 67.1844",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M144.077 67.6699L144.201 67.7939",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M190.579 129.455C191.697 128.876 192.925 128.542 194.182 128.478",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M109.066 148.936L116.285 154.174",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M189.144 158.546C190.196 159.365 190.89 160.56 191.081 161.88",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M168.005 153.818L166.042 155.792",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M154.734 140.272C153.438 141.96 151.577 143.124 149.492 143.551",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M139.238 23.3588H94.0735C92.7966 23.3626 91.7646 24.4007 91.7683 25.6775V46.4701C91.7646 47.7469 92.7966 48.785 94.0735 48.7887H123.598C124.788 50.2998 126.146 52.0211 127.132 53.2715C127.588 53.8494 128.507 53.5177 128.507 52.78V48.7887H139.238C140.515 48.785 141.547 47.7469 141.543 46.4701V25.6775C141.547 24.4007 140.515 23.3626 139.238 23.3588Z",
    fill: "#0084F0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.238 23.3588H94.0735C92.7966 23.3626 91.7646 24.4007 91.7683 25.6775V46.4701C91.7646 47.7469 92.7966 48.785 94.0735 48.7887H123.598C124.788 50.2998 126.146 52.0211 127.132 53.2715C127.588 53.8494 128.507 53.5177 128.507 52.78V48.7887H139.238C140.515 48.785 141.547 47.7469 141.543 46.4701V25.6775C141.547 24.4007 140.515 23.3626 139.238 23.3588Z",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.818,
    cy: 35.3785,
    rx: 2.30249,
    ry: 2.3159,
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.444,
    cy: 35.3785,
    rx: 2.30249,
    ry: 2.3159,
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.069,
    cy: 35.3785,
    rx: 2.30249,
    ry: 2.3159,
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.694,
    cy: 35.3785,
    rx: 2.30249,
    ry: 2.3159,
    fill: "white",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M132.736 41.8797C131.562 42.9305 130.27 43.8409 128.886 44.5925",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M104.81 26.3204L104.141 27.3312",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M136.449 42.6942L133.818 45.1481",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M212.85 57.668L210.974 61.6498",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M190.853 62.839C190.249 63.8584 189.392 64.7047 188.365 65.296",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M175.595 151.452C175.582 153.441 174.795 155.347 173.401 156.766",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0078 166.125C80.8402 167.188 81.9026 168.048 83.1153 168.642",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0493 132.718C64.4496 133.406 65.1493 133.866 65.9392 133.96",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2458 30.2483C36.1253 32.2039 36.5732 34.1526 37.5354 35.8594",
    stroke: "#143C9A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.8cadb78f50204b199a07f8daae3dfc15.svg";
export { ForwardRef as ReactComponent };